import React from "react";

import Spinner from "components/spinner";

const Loading: React.FC = () => (
  <>
    <div className="text-center">
      <p>Looking up link code ...</p>
    </div>

    <div className="text-center">
      <Spinner size={24} />
    </div>
  </>
);

export default Loading;
